import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { Row, Col } from 'react-flexbox-grid';

class PageNotFound extends React.Component {

  constructor(props) {
    super(props);
    this.handleRoute = this.handleRoute.bind(this);
  }

  handleRoute() {
    this.context.router.push('/');
  }

  render() {
    return (
      <Row center="xs" middle="xs" style={{ padding: 16 }}>
        <Col xs={12} sm={6}>
          <Paper>
            <Row center="xs" middle="xs">
              <Col xs={12} style={{ paddingTop: 20, fontSize: 65, fontWeight: 300 }}>
                <span>404</span>
              </Col>
              <Col xs={12} style={{ paddingBottom: 20, paddingTop: 10 }}>
                <span style={{ fontSize: 20, fontWeight: 300 }}>
                  Þessi síða er ekki til!
                </span>
              </Col>
              <Col xs={12} style={{ paddingBottom: 20 }}>
                <RaisedButton
                  secondary
                  label="Heim"
                  onClick={this.handleRoute}
                />
              </Col>
            </Row>
          </Paper>
        </Col>
      </Row>
    );
  }
}

PageNotFound.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js